import { action, observable, makeObservable } from 'mobx';
import { JSX, RefObject } from 'react';

import { IToastOptions, ToastType, TToastStyle } from './ToastStore.types';

const DEFAULT_OPTIONS: IToastOptions = {
  durationMs: 2000,
  style: '5',
};

class CToast {
  @observable isVisible = false;
  @observable content: JSX.Element | string | null = null;
  @observable type: ToastType = ToastType.Global;
  @observable style: TToastStyle = '5';
  @observable targetRef: RefObject<HTMLElement> | undefined = undefined;
  timeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    makeObservable(this);
  }

  @action
  show(content: JSX.Element | string, options: Partial<IToastOptions> = DEFAULT_OPTIONS): void {
    this.reset();

    const { durationMs, type, targetRef, style } = {
      ...DEFAULT_OPTIONS,
      ...options,
    };

    this.content = content;
    this.isVisible = true;
    this.targetRef = targetRef || undefined;
    this.type = type || ToastType.Global;
    this.style = style || '5';

    this.timeout = setTimeout(() => {
      this.hide();
    }, durationMs);
  }

  @action
  hide(): void {
    this.isVisible = false;
  }

  @action
  reset(): void {
    this.content = null;
    this.isVisible = false;
    this.type = ToastType.Global;
    this.targetRef = undefined;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}

export const ToastStore = new CToast();
export type IToastStore = typeof ToastStore;
